<template>
  <section
    v-if="render"
    :class="$style.root"
  >
    <template
      v-for="(block, index) in blocks"
      :key="block?.id"
    >
      <CoreBlocksTextComponent
        v-if="block?.__component === 'blocks.text'"
        :block="block"
      />
      <CoreBlocksImagesComponent
        v-else-if="block?.__component === 'blocks.images'"
        :block="block"
      />
      <CoreBlocksHeadingComponent
        v-else-if="block?.__component === 'blocks.heading'"
        :block="block"
        :margin-top="index > 0"
      />
      <CoreBlocksVideoComponent
        v-else-if="block?.__component === 'blocks.video'"
        :block="block"
      />
      <!-- note childPageName is not a universal solution and expects the block to placed on specific pages -->
      <CoreBlocksWorksComponent
        v-else-if="block?.__component === 'blocks.permanent-works' || block?.__component === 'blocks.works'"
        :block="block"
        :childPageName="block?.__component === 'blocks.permanent-works' ? 'permanent-works-slug' : 'program-slug-secondaryslug'"
      />
      <CoreBlocksQuoteComponent
        v-else-if="block?.__component === 'blocks.quote'"
        :block="block"
      />
      <CoreBlocksExternalLinksComponent
        v-else-if="block?.__component === 'blocks.external-links'"
        :block="block"
      />
      <CoreBlocksTextImageComponent
        v-else-if="block?.__component === 'blocks.text-image'"
        :block="block"
      />
      <CoreBlocksSponsorsComponent
        v-else-if="block?.__component === 'blocks.sponsors'"
        :block="block"
      />
      <CoreBlocksStripeComponent
        v-else-if="block?.__component === 'blocks.stripe'"
        :block="block"
      />
    </template>
  </section>
</template>

<script setup>
const props = defineProps({
  blocks: {
    type: [Object, Array]
  }
})

const blocks = computed(() => {
  return props?.blocks?.filter(i => {
    const localizedData = i18nGetLocalizedData(i)
    if (i?.__component === 'blocks.text') {
      return localizedData?.current_locale
    } else if (i?.__component === 'blocks.heading') {
      return localizedData?.current_locale
    } else if (i?.__component === 'blocks.images') {
      return localizedData?.images?.data?.length > 0
    } else if (i?.__component === 'blocks.video') {
      return localizedData?.video?.url?.length > 0
    } else if (i?.__component === 'blocks.permanent-works' || i?.__component === 'blocks.works') {
      return localizedData?.entries?.data?.length > 0
    } else if (i?.__component === 'blocks.quote') {
      return localizedData?.current_locale
    } else if (i?.__component === 'blocks.external-links') {
      return localizedData?.external_links?.length > 0
    } else if (i?.__component === 'blocks.text-image') {
      return localizedData?.image?.data?.id && localizedData?.texts?.current_locale
    } else if (i?.__component === 'blocks.sponsors') {
      return localizedData?.sponsors?.length
    } else if (i?.__component === 'blocks.stripe') {
      return localizedData?.stripe_product?.data?.attributes?.stripe_product_id !== undefined && localizedData?.stripe_price?.data?.attributes?.stripe_price_id !== null
    } else {
      return false
    }
  })
})

const render = computed(() => {
  return blocks?.value?.length > 0
})
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical--double) * 2);
}
</style>
